export default function getUID() {
    return (Date.now() + Math.random() * 100000).toFixed();
}
